export default __webpack_public_path__ + "static/media/ic-test-published.e8f0772d.svg";